import { StateCreator } from 'zustand';

import { PhoneVerificationSlice } from './types';

const initialState = {
  isModalOpen: false,
  hasBeenShown: false,
  showWelcomeHeader: false,
};

const phoneVerificationSlice: StateCreator<PhoneVerificationSlice> = (set) => ({
  ...initialState,
  openModal: () => set({ isModalOpen: true, hasBeenShown: true }),
  closeModal: () => set({ isModalOpen: false }),
  setShowWelcomeHeader: (showWelcomeHeader: boolean) => set({ showWelcomeHeader }),
  resetPhoneVerificationData() {
    set({ ...initialState });
  },
});

export default phoneVerificationSlice;
